import { render, staticRenderFns } from "./Regra.vue?vue&type=template&id=6b930846"
import script from "./Regra.vue?vue&type=script&lang=js"
export * from "./Regra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports